<template>
	<c-dialog ref="dialog" width="800" height="800" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<power-tree :power-list="powerList"></power-tree>
		</c-form>
	</c-dialog>
</template>

<script>
function renderPower(h, list, parent) {
	var arr = [], last = !list.find(item => item.child_menu_list && item.child_menu_list.length);
	list.map(item => {
		item.parent = parent;

		arr = arr.concat([
			<div class="power-item" style={`float: ${last ? 'left' : 'none'}`}>
				<c-checkbox value={item.chk != 0} on-change={$event => this.checkHandle(item, $event)}>{item.menu_name}</c-checkbox>
				{
					item.child_menu_list && item.child_menu_list.length ? [
						<div class="power-list">
							{
								renderPower.call(this, h, item.child_menu_list, item)
							}
						</div>
					] : []
				}
			</div>
		]);
	});

	return arr;
}

const powerTree = {
	render(h) {
		return (
			<div class="power">
				{
					renderPower.call(this, h, this.powerList)
				}
			</div>
		)
	},

	props: {
		powerList: Array
	},

	methods: {
		checkHandle(power, state) {
			state = state ? 1 : 0;

			power.chk = state;
			!function poll(list) {
				list && list.forEach(item => {
					item.chk = state;
					poll(item.child_menu_list);
				});
			}(power.child_menu_list);

			!function poll(parent) {
				if (parent) {
					parent.chk = parent.child_menu_list.find(item => !!item.chk) ? 1 : 0;
					poll(parent.parent);
				}
			}(power.parent);
		}
	}
};
export default {
	components: {
		powerTree
	},

	data() {
		return {
			saasId: '',
			powerList: []
		}
	},

	methods: {
		/*********打开编辑框，初始化**********/
		open(data, ref_client) {
			this.ref_client = ref_client;
			this.saasId = data.saas_id;
			this.powerList = [];
			this.request({
				url: '/sys_saas/saas_menu_list',
				data: {
					saas_id: data.saas_id,
					ref_client: ref_client
				},
				success: data => {
					this.powerList = data;
				}
			});
			//填充form表单
			this.$refs.dialog.open({
				title: '商户【'+ data.saas_id + ' / '+data.saas_name+'】' + (ref_client == 0?'电脑端权限设置':'移动端权限设置')
			});
		},
		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: '/sys_saas/saas_menu_edit',
				dataFormatter: () => {
					let data = [];
					!function poll(list) {
						list && list.forEach(item => {
							if (item.chk) {
								data.push(item.id);
							}
							poll(item.child_menu_list);
						});
					}(this.powerList);
					return {
						saas_id: this.saasId,
						ref_client: this.ref_client,
						menu_ids: data
					};
				},
				success: (data, res) => {
					next();
					this.$message({
						message: '提交成功',  // 提示内容,
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
	>>> .power {
		box-sizing: border-box;
		width: 100%;
		border: 1px solid #ddd;
		overflow: auto;
			
		&-list {
			margin-left: 40px;
			overflow: hidden;
		}
		
		> &-item {
			margin-left: 20px;
			
			&:nth-last-child(1) {
				margin-bottom: 15px;
			}
		}
		
		&-item {
			margin-top: 15px;
			margin-right: 20px;
		}
	}
</style>